<template>
  <div ref="content_Ref" style="height: 100%; width: 100%" class="sip-view">
    <div style="display: none" class="audio-dom">
      <audio autoplay id="audio" ref="audio" controls :muted="muted"></audio>
    </div>
    <canvas ref="canvas_Ref" class="canvas_audio" />
    <p v-if="mobile == 'iOS'" class="ios-tip">
      如果没有声音，点击 <span @click="openMuted">开启声音</span>
    </p>
    <p class="talkTime">{{ talkTime }}</p>
    <p class="tip">通话时长3分钟，超时后强制挂断</p>
    <span class="version">v1.0.4</span>
    <div class="record-btn-box" @click="stopTalk" v-show="confirmed">
      <p class="record-btn"></p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import initAudio from "@/utils/AudioLine";
import UserAgent from "@/utils/UserAgent.js";

const confirmed = ref(false); // 当前通话是否建立

var audio = ref();

const canvas_Ref = ref();
const content_Ref = ref();
const muted = ref(true);

let isBack = false
function audioTime(time) {
  time = Math.floor(time);
  let h = Math.floor(time / 3600);
  let m = Math.floor((time % 3600) / 60);
  let s = time % 60;
  h = h >= 10 ? h : "0" + h;
  m = m >= 10 ? m : "0" + m;
  s = s >= 10 ? s : "0" + s;
  return h + ":" + m + ":" + s;
}
const time = ref(0);
let inter = null;
const talkTime = computed(() => {
  return audioTime(time.value);
});
const startTalk = () => {
  confirmed.value = true;
  clearInterval(inter);
  inter = setInterval(() => {
    time.value++;
    if (time.value > 3 * 60) {
      // 超过3分钟自动挂断
      stopTalk();
    }
  }, 1000);
};
const stopTalk = () => {
  clearInterval(inter);
  time.value = 0;
  testTerminate();
  if (!isBack) {
    isBack = true
    window.wx.miniProgram.navigateBack();
  }

};

const openMuted = () => {
  muted.value = false;
  audio.value.volume = 1;
  audio.value.play()
};
var userAgent = null;
function gotRemoteMedia(stream) {
  console.log("gotRemoteMedia");
  if ("srcObject" in audio.value) {
    audio.value.srcObject = stream;
  } else {
    console.info("Received local media stream");
    audio.value.src = URL.createObjectURL(stream);
  }
  muted.value = false; // 在播放开始后取消静音
  initAudio(stream, canvas_Ref.value);
}

function captureLocalMedia(callBack) {
  console.info("Requesting local audio");
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // 调用 getUserMedia 方法
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(() => {
        // 成功获取媒体流后的处理逻辑
        callBack && callBack();
      })
      .catch(function (err) {
        // 处理错误逻辑
        console.log("Error accessing media devices.", err);
        if (!isBack) {
          isBack = true
          window.wx.miniProgram.navigateBack();
        }
      });
  } else {
    // 处理不支持的情况
    console.log("getUserMedia is not supported in this browser.");
    if (!isBack) {
      isBack = true
      window.wx.miniProgram.navigateBack();
    }
  }
}
function testTerminate() {
  userAgent?.currentSession?.terminate();
}
function ended() {
  clearInterval(inter);
  confirmed.value = false;
  if (!isBack) {
    isBack = true
    window.wx.miniProgram.navigateBack();
  }
}

const unload = () => {
  if (confirmed.value) {
    stopTalk();
  }
  userAgent?.destroy();
  userAgent = null;
  testTerminate();
  ended();
};

const registered = () => {
  userAgent?.testCall();
};
const mobile = ref("Android");
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // 检测 iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }
  // 检测 Android
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  return "unknown"; // 如果既不是iOS也不是Android，则返回未知
}
onMounted(() => {
  mobile.value = getMobileOperatingSystem();
  console.log(mobile.value);
  let arr = location.href.split("?")[1]?.split("&") || [];
  let options = {};
  arr.forEach((item) => {
    let key = item.split("=")[0];
    let value = item.split("=")[1];
    options[key] = value;
  });
  window.addEventListener("unload", unload);
  captureLocalMedia(() => {
    userAgent = new UserAgent({
      wssUrl: "wss://gas.ideteck.com:8085",
      sipUrl: "121.196.247.40",
      userNumber: options.sipAccount || 250300030,
      deviceNumber: options.callSipAccount || 250300050,
      password: options.password || "a355a028",
      gotRemoteMedia: gotRemoteMedia,
      startTalk,
      ended,
      registered,
    });
  });
});
onBeforeUnmount(() => {
  unload();
});
</script>

<style scoped>
.ios-tip {
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;

  span {
    color: #31a7ff;
  }
}

.version {
  position: absolute;
  right: 0;
  bottom: 0;
}

.sip-view {
  height: 100%;
  width: 100%;
  background-color: #333;
  color: #fff;
}

.audio-dom {
  position: absolute;
  /* left: -100%; */
  top: 100px;
}

.talkTime {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #31a7ff;
  font-size: 40px;
}

.tip {
  position: fixed;
  bottom: 10px;
  left: 20px;
  color: #fff;
  font-size: 16px;
}

.record-btn-box {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.record-btn {
  width: 60px;
  height: 60px;
  border: 4px solid #d9001b;
  position: relative;
  border-radius: 100%;
  margin-bottom: 5px;
}

.record-btn::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 20%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #d9001b;
}

.canvas_audio {
  position: absolute;
  width: 50%;
  height: 200px;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -20%);
}

.btn {
  width: 80%;
  height: 60px;
  border: 1px solid #ddd;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
}

.create {
  background-color: #31a7ff;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
}

.close {
  background-color: #ff0000;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
}
</style>
